import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Phone } from 'lucide-react';
import { SITE } from '../data/mock';

/**
 * CTA banner shown at the bottom of marketing pages.
 *
 * All copy is overridable per-page via props (which Home.jsx fills from the
 * admin v2 `cta_banner` section). Defaults stay reasonable so calling
 * `<CtaBanner />` with no props still renders the legacy banner.
 */
export default function CtaBanner({
  eyebrow = 'Get Started',
  title = 'Ready to upgrade your business communications?',
  subtitle = 'Start your 14-day free trial — no credit card, no contract, no risk.',
  primaryLabel,
  primary,             // legacy alias
  primaryHref = '/contact',
  secondaryLabel = 'Talk to Sales',
  secondaryHref,
}) {
  const primaryText = primaryLabel || primary || 'Start Free Trial';
  return (
    <section className="relative overflow-hidden">
      <div className="container-x section-pad">
        <div className="relative isolate rounded-3xl mesh-bg p-8 md:p-14 overflow-hidden">
          <div className="absolute inset-0 dot-pattern opacity-40 pointer-events-none" />
          <div className="absolute -right-16 -top-16 w-72 h-72 bg-violet-500/30 rounded-full blur-3xl" />
          <div className="absolute -left-20 -bottom-20 w-72 h-72 bg-fuchsia-500/20 rounded-full blur-3xl" />

          <div className="relative grid md:grid-cols-2 gap-8 items-center">
            <div>
              <span className="eyebrow-dark mb-4">{eyebrow}</span>
              <h2 className="text-white text-3xl md:text-4xl font-extrabold leading-tight mb-4">{title}</h2>
              <p className="text-violet-100/80 text-base md:text-lg">{subtitle}</p>
            </div>
            <div className="flex flex-col sm:flex-row gap-3 md:justify-end">
              <Link to={primaryHref} className="btn-primary justify-center">
                {primaryText} <ArrowRight size={16} />
              </Link>
              {secondaryHref ? (
                <Link to={secondaryHref} className="btn-ghost justify-center">
                  <Phone size={16} /> {secondaryLabel}
                </Link>
              ) : (
                <a href={`tel:${SITE.phoneTel}`} className="btn-ghost justify-center">
                  <Phone size={16} /> {secondaryLabel}
                </a>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
